import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";

export default function CircularIndeterminate() {
  return (
    <Box sx={{ width:"100%",  display: "flex", my: 3, alignItem: "center", justifyContent: "center" }}>
      <CircularProgress sx={{ width: 4 }} />
    </Box>
  );
}
